import { addSlidesTabIndex } from '@parent-theme/assets/js/helpers/swiper/add-slides-tab-index';
import Gravity from '@parent-theme/assets/js/global-functions';

const dynamicSliderInit = () => {
    const mainPattern = document.querySelectorAll('.gg-office-locations');

    mainPattern.forEach((module) => {
        const swipers = module.querySelector('.posts-result');
        const swiperWrapper = module.querySelector('.gravity-block-dynamic-boxes--grid-view');
        const swiperSlides = module.querySelectorAll('.gravity-block-dynamic-boxes__box');

        if (!swipers || !swiperWrapper) {
            return;
        }

        let init = false;
        let carousel = null;

        const handleCarouselBasedOnWindowWidth = () => {
            if (window.innerWidth < 640) {
                if (!init) {
                    init = !init;

                    swipers.classList.add('swiper-container');
                    swiperWrapper.classList.add('swiper-wrapper');
                    swiperSlides.forEach((slide) => {
                        slide.classList.add('swiper-slide');
                    });

                    carousel = new window.Swiper(swipers, {
                        loop: false,
                        centeredSlides: false,
                        watchOverflow: true,
                        watchSlidesProgress: true,
                        slidesPerGroup: 1,
                        slidesPerView: 'auto',
                        allowTouchMove: true,
                        breakpoints: {
                            480: {
                                slidesPerView: 1.5,
                                spaceBetween: 24,
                            },
                            200: {
                                slidesPerView: 1.1,
                                spaceBetween: 24,
                            },
                        },
                        on: {
                            init: (swiper) => addSlidesTabIndex(swiper),
                            slideChange: (swiper) => addSlidesTabIndex(swiper),
                        },
                    });

                    carousel.init();
                }
            } else if (init) {
                init = !init;
                carousel.destroy();

                swipers.classList.remove('swiper-container');
                swiperWrapper.classList.remove('swiper-wrapper');
                swiperSlides.forEach((slide) => {
                    slide.classList.remove('swiper-slide');
                });
            }
        };

        handleCarouselBasedOnWindowWidth();
        window.addEventListener('resize', Gravity.debounce(handleCarouselBasedOnWindowWidth, 50));
    });
};
dynamicSliderInit();
